export const ADD_ADDRESSBOOK_SUCCESS = 'ADD_ADDRESSBOOK_SUCCESS',
  ADD_ADDRESSBOOK_FAIL = 'ADD_ADDRESSBOOK_FAIL',
  GET_ADDRESSBOOK_START = 'GET_ADDRESSBOOK_START',
  GET_ADDRESSBOOK = 'GET_ADDRESSBOOK',
  REMOVE_ADDRESSBOOK_SUCCESS = 'REMOVE_ADDRESSBOOK_SUCCESS',
  REMOVE_ADDRESSBOOK_FAIL = 'REMOVE_ADDRESSBOOK_FAIL',
  EDIT_ADDRESSBOOK_SUCCESS = 'EDIT_ADDRESSBOOK_SUCCESS'
